import { render, staticRenderFns } from "./Fileimport.vue?vue&type=template&id=01f4363d&scoped=true&"
import script from "./Fileimport.vue?vue&type=script&lang=js&"
export * from "./Fileimport.vue?vue&type=script&lang=js&"
import style0 from "./Fileimport.vue?vue&type=style&index=0&id=01f4363d&scoped=scoped&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f4363d",
  null
  
)

export default component.exports